import { Typography, useMediaQuery } from '@mui/material';
import React from 'react';

const COPPAPolicices = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  return (
    <div>
      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '21px' : '48px',
          fontWeight: 800,
          color: 'white',
          textAlign: 'center',
          paddingBottom: isMobile ? '20px' : '40px'
        }}>
        Children’s Online Privacy Protection Policy (COPPA) – Champsverse
      </Typography>

      <Typography
        style={{
          fontSize: isMobile ? '14px' : '24px',
          fontFamily: 'Baloo2',
          fontWeight: 500,
          padding: isMobile ? '5px 0' : '10px 0',
          color: 'white',
          margin: isMobile ? '0 5%' : '0 10%'
        }}>
        At Champsverse, we take the privacy and protection of children very seriously. This COPPA Policy explains how we
        collect, use, and protect the personal information of children under the age of 13 in compliance with the
        Children’s Online Privacy Protection Act (COPPA).
      </Typography>
      <ol style={{ color: 'white', margin: isMobile ? '0 5%' : '0 10%' }}>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Information We Collect
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            We may collect the following types of information from children under 13, only with verifiable parental
            consent:
          </Typography>
          <ul
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: '10px 50px'
            }}>
            <li>First name or nickname (never full name)</li>
            <li>Age or birth year (to ensure age-appropriate experiences)</li>
            <li>Creative submissions (such as drawings, stories, or videos)</li>
            <li>Usage data (like app activity or progress)</li>
          </ul>
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            We do not collect:
          </Typography>
          <ul
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: '10px 50px'
            }}>
            <li>Contact information (email, phone) directly from the child</li>
            <li>Location data beyond city or region (if at all)</li>
          </ul>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          How We Use This Information
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500
            }}>
            We use this information to:
          </Typography>
          <ul
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: '10px 50px'
            }}>
            <li>Customize and improve the Champsverse experience</li>
            <li>Track progress and rewards</li>
            <li>Feature or celebrate creative work (with consent)</li>
            <li>Communicate with parents or guardians</li>
          </ul>
        </li>

        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Parental Consent and Control
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            Before we collect any personal information from a child, we obtain verifiable parental consent through:
          </Typography>
          <ul
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: '10px 50px'
            }}>
            <li>Email confirmation with a follow-up validation step</li>
            <li>Consent forms signed and returned</li>
            <li>Parent account registration linked to the child’s profile</li>
          </ul>
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            Parents have the right to:
          </Typography>
          <ul
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: '10px 50px'
            }}>
            <li>Review the personal information we have collected from their child</li>
            <li>Request deletion of the information</li>
            <li>Refuse to allow further collection or use of the child’s information</li>
          </ul>
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            To make any such request, please contact us at admin@champsverse.com.
          </Typography>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Data Security and Retention
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            We implement strict safeguards to protect your child&apos;s information, including encryption and access
            control. We retain data only as long as needed for the purposes above or as required by law.
          </Typography>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Third Parties
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            We do not share children&apos;s personal information with third parties for marketing purposes. Limited
            service providers (such as cloud storage or moderation tools) may access data solely to provide services to
            Champsverse and are bound by strict confidentiality agreements.
          </Typography>
        </li>
        <li
          style={{
            fontSize: isMobile ? '21px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Changes to This Policy
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0' : '10px 0'
            }}>
            We may update this COPPA policy from time to time. If we make material changes, we will notify parents via
            email or through prominent notices within the app.
          </Typography>
          <Typography
            style={{
              fontSize: isMobile ? '14px' : '24px',
              fontFamily: 'Baloo2',
              fontWeight: 500,
              padding: isMobile ? '5px 0 20% 0' : '10px 0 20% 0'
            }}>
            If you are a parent or guardian and believe your child has provided personal information without your
            consent, please contact us immediately at admin@champsvere.com.
          </Typography>
        </li>
      </ol>
    </div>
  );
};

export default COPPAPolicices;
